<script lang="ts">
  /* The three things you do WITH a route, pinned below the scroll.
   *
   * Pinned because the schedule above them is long enough to scroll on a phone,
   * and the desktop route box put EXPORT GPX below the fold of a
   * `max-height: calc(100dvh - 190px)` panel most people never thought to
   * scroll. */
  import { editor } from '@gennetay/chart-core/lib/editor.svelte';
  import { downloadRouteGpx } from '@gennetay/chart-core/lib/gpx';
  import { autoroute } from '@gennetay/chart-core/lib/autoroute.svelte';
  import { trips } from '@gennetay/chart-core/lib/trip.svelte';
  import Button from '@gennetay/chart-ui/primitives/Button';
  import ButtonRow from '@gennetay/chart-ui/primitives/ButtonRow';

  let saved = $state(false);

  function save() {
    trips.create({
      name: 'Route',
      points: editor.pts.map((p) => ({ lat: p.lat, lon: p.lon })),
      departT: autoroute.departT,
      boatKn: autoroute.boatKn,
      useCurrents: autoroute.useCurrents
    });
    /* Confirmed in place rather than with a toast. A toast is a thing that
       appears somewhere else and goes away; on a moving deck the answer to "did
       that work" should be under the thumb that asked. */
    saved = true;
    setTimeout(() => (saved = false), 2000);
  }
</script>

<!-- ═══ TWO, NOT FOUR ═══
     This carried DELETE POINT and UNDO as well, and on a phone held sideways
     the sheet is a 340 px column: four 44 px buttons wrapped into a block
     116 px tall and left the panel's BODY 42 px — the schedule the panel exists
     to show, squeezed to nothing by the actions pinned under it.
     `_mobile-proof.mjs` caught it.

     The foot is for the one or two things you do WITH a finished plan. Deleting
     a point and undoing are EDITS, and they belong beside the route they edit —
     which is where they are now, in the body. -->
<ButtonRow>
  <Button intent={saved ? 'on' : 'primary'} onclick={save}>
    {saved ? 'Saved' : 'Save trip'}
  </Button>
  <!-- The ONLY way a route leaves this chart. There is no server to write to
       and no business inventing an account system to get one, so it leaves as a
       file — the door every plotter already has. -->
  <Button
    onclick={() =>
      downloadRouteGpx('Gennetay route', editor.pts.map((p) => ({ lat: p.lat, lon: p.lon })))}
  >Export GPX</Button>
</ButtonRow>
